import { render, staticRenderFns } from "./professor.vue?vue&type=template&id=c197de9e&scoped=true&"
import script from "./professor.vue?vue&type=script&lang=js&"
export * from "./professor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c197de9e",
  null
  
)

export default component.exports